import { useEffect, useRef, useState } from 'react';
import { Button } from '@mui/joy';
import { Icon } from './UI';
import * as api from './api';

export function useMeetingClock(meeting) {
  const sampledNow = Date.now();
  const [now, setNow] = useState(sampledNow);
  const clock = useRef({ stamp: null, offset: 0 });
  if (meeting?.server_now && clock.current.stamp !== meeting.server_now) {
    clock.current = { stamp: meeting.server_now, offset: new Date(meeting.server_now).getTime() - sampledNow };
  }
  useEffect(() => { const tick = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(tick); }, []);
  return meeting?.expires_at ? Math.max(0, Math.ceil((new Date(meeting.expires_at).getTime() - now - clock.current.offset) / 1000)) : null;
}
export function RemainingTime({ meeting }) {
  const remaining = useMeetingClock(meeting);
  return remaining === null ? <>{meeting.planned_minutes} мин</> : <>Осталось {Math.floor(remaining / 60)}:{String(remaining % 60).padStart(2, '0')}</>;
}
export function ExtendMeeting({ meeting, onDone, onError }) {
  const [busy, setBusy] = useState(false);
  async function extend(minutes) {
    if (busy) return;
    setBusy(true);
    try { await api.extend(meeting, minutes); await onDone?.(); }
    catch (e) { await onDone?.(); onError?.(api.error(e)); }
    finally { setBusy(false); }
  }
  return <div className="mm-extend-buttons" aria-label="Продление встречи">{[15, 30, 60].map(minutes => <Button key={minutes} size="sm" variant="soft" disabled={busy} onClick={() => void extend(minutes)}>+{minutes} мин</Button>)}</div>;
}
export default function MeetingTimeNotice({ snapshot, refresh }) {
  const meeting = snapshot?.meeting, remaining = useMeetingClock(meeting);
  const [dismissed, setDismissed] = useState(''), [error, setError] = useState('');
  const noticeKey = meeting ? meeting.id + ':' + meeting.expires_at : '';
  if (snapshot?.member?.role !== 'owner' || meeting?.status !== 'live' || remaining === null || remaining > 600 || dismissed === noticeKey) return null;
  return <aside className="mm-time-notice" aria-label="Время встречи"><div className="mm-time-notice-title"><Icon name="clock"/><strong>{remaining > 0 ? `Встреча завершится через ${Math.ceil(remaining / 60)} мин` : 'Время встречи истекло'}</strong></div><p>Продлите разговор или оставьте автоматическое завершение для всех.</p>{remaining > 0 && <ExtendMeeting meeting={meeting} onDone={refresh} onError={setError}/>}<button type="button" className="mm-time-dismiss" onClick={() => { setDismissed(noticeKey); setError(''); }}>Понятно</button>{error && <p className="mm-error" role="alert">{error}</p>}</aside>;
}
